<div class="min-h-screen bg-(--pg-bg) text-(--pg-text)">
	<div class="h-[64px]">
		<app-header></app-header>
	</div>
	<div class="h-[calc(100vh-96px)] overflow-auto">
		<side-drawer-menu></side-drawer-menu>
		<main class=" h-full w-full px-4 py-6 sm:px-6 lg:px-10">
			<router-outlet />
		</main>
	</div>
	<div class="h-[32px]">
		<app-footer></app-footer>
	</div>
	<app-toast-container></app-toast-container>
</div>
